// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

const _search = url =>
  wrapWithNetworkError(function search(
    token: string,
    query: { [string]: string }
  ) {
    const fetchUrl = getEndpointUrl(url);
    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        Authorization: token,
      },

      body: JSON.stringify(query),
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => response.json());
  });

const _ugcSearch = url =>
  wrapWithNetworkError(function search(
    token: string,
    query: { [string]: string }
  ) {
    const params = new URLSearchParams(query);
    const clientId = params.get('client_id');
    const comments = params.get('comments_keywords');
    const endDate = params.get('end_date').slice(0, 10);
    const startDate = params.get('start_date').slice(0, 10);

    params.append('from_date', startDate);
    params.append('to_date', endDate);
    params.append('max_page_results', 100);
    if (comments != null) {
      params.append('comments', params.get('comments_keywords'));
      params.delete('comments_keywords');
    }
    params.delete('sort_order');
    params.delete('start_date');
    params.delete('end_date');
    params.delete('client_id');

    const fetchUrl = getEndpointUrl(`${url}/${clientId}?${params.toString()}`);
    const fetchOptions = {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        Authorization: token,
      },
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => response.json());
  });

export const nativeSearch = _search('/cdm/ugc/search');
export const networkSearch = _search('/cdm/ugc/search/network');
export const ugcSearch = _ugcSearch('/cdm/ugc/search');



// WEBPACK FOOTER //
// ./src/api/content/search.js